import { ModelSagres } from "../../model-sagres"

export class ContasInativar extends ModelSagres {
    codigoBanco: number
    codigoAgencia: string
    numeroContBancaria: string
    tipoContBancaria: string
    flInativo: "S" | "N"
    descricaoContBancaria: string
    descricaoTipoContBancaria: string

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.CodigoBanco) this.codigoBanco = obj.CodigoBanco
            if (obj.CodigoAgencia) this.codigoAgencia = obj.CodigoAgencia
            if (obj.NumeroContBancaria) this.numeroContBancaria = obj.NumeroContBancaria
            if (obj.TipoContBancaria) this.tipoContBancaria = obj.TipoContBancaria
            if (obj.FlInativo) this.flInativo = obj.FlInativo
            if (obj.DescricaoContBancaria) this.descricaoContBancaria = obj.DescricaoContBancaria
            if (obj.DescricaoTipoContBancaria) this.descricaoTipoContBancaria = obj.DescricaoTipoContBancaria
        }
    }
}